module.exports = __webpack_public_path__ + "static/img/howUseUpiIN.df54627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upiTeaching/howUseUpiIN.png
// module id = XuNM
// module chunks = 0